<template>
  <div class="flex size-full flex-col px-3 text-gray-700 md:p-0">
    <p class="text-left text-xl md:text-2xl">
      <span class="">¿Cuál es el </span>
      <span class="font-serif">nombre</span>
      <span class=""> de tu tienda?</span>
    </p>
    <form
      class="mt-5 flex w-full flex-col md:mt-8"
      @submit.prevent="onSubmit"
    >
      <custom-input
        v-model="signUpStore.shopForm.name"
        class=""
        name="shopName"
        label="Nombre de tu tienda"
        placeholder="Nombre de tu tienda"
        :rules="{ required: true }"
      />
      <custom-input
        v-model="signUpStore.shopForm.webpageLink"
        class="mt-5 md:mt-8"
        name="shopWebpageLink"
        label="Página web o redes sociales"
        placeholder="Página web o redes sociales"
        :rules="{ required: true }"
      />
      <div class="mt-5 flex w-full flex-col items-center md:mt-8">
        <button
          class="w-full rounded-md bg-gray-700 p-2 text-sm text-white md:text-base"
          :class="{ 'opacity-80': anyErrors, 'hover:bg-gray-800': !anyErrors }"
          :disabled="anyErrors"
        >
          Continuar
        </button>
        <a
          class="mt-1 cursor-pointer text-xs hover:underline md:text-sm"
          @click="previousStep"
        >
          Volver
        </a>
      </div>
    </form>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { useForm } from 'vee-validate';
import useSignUpStore from 'stores/sign-up-store';
import customInput from './shared/custom-input.vue';

const signUpStore = useSignUpStore();

const anyErrors = computed(() => Object.keys(errors.value).length > 0);

function previousStep() {
  signUpStore.currentStep = 'shop-kind';
}

const { handleSubmit, errors } = useForm();
const onSubmit = handleSubmit(() => {
  signUpStore.currentStep = 'shop-category';
});
</script>
